import 'flowbite';
import React from 'react'
import ReactDOM from 'react-dom/client'
import GetStartedContainer from '../containers/GetStarted'

const root = document.getElementById('get_started')
if (root) {
  ReactDOM.createRoot(root).render(<GetStartedContainer />)
}
